import PropTypes from 'prop-types';

export const WorkstationPropType = PropTypes.shape({
  workstationId: PropTypes.string.isRequired,
  userId: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  isOnline: PropTypes.bool,
});

export const DevicePropType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string,
  description: PropTypes.string,
  disabled: PropTypes.bool.isRequired,
  shared: PropTypes.bool.isRequired,
  workstationId: PropTypes.string.isRequired,
});
